import {makeAutoObservable} from 'mobx'
import {DataObjectId} from 'yougile-model'
import {ChatUtils} from '@extensions/chat-utils'

interface State {
  path: DataObjectId[]
  transition: boolean
}

class ParentNavigationStore {
  state: State = {
    path: [],
    transition: false
  }

  constructor() {
    makeAutoObservable(this)
    ChatUtils.addChatChangeListener(() => {
      if (this.state.transition) {
        this.state.transition = false
      } else {
        this.clear()
      }
    })
  }

  goBack() {
    this.state.transition = true
    ChatUtils.openChatById(this.state.path.pop())
  }

  addParent(id: DataObjectId) {
    this.state.transition = true
    this.state.path.push(id)
  }

  clear() {
    this.state.path = []
  }
}

export const parentNavigationStore = new ParentNavigationStore()
